import { render, staticRenderFns } from "./EmbeddedChatConversation.vue?vue&type=template&id=839f5df4&"
import script from "./EmbeddedChatConversation.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedChatConversation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports